import LeadDetails from "./LeadDetails/LeadDetails";

export default function LeadDetailsWrapper() {
  return <LeadDetails />;
}
